// extracted by mini-css-extract-plugin
export var fileUpload = "_ii-1";
export var modalButton = "_ii-0";